<template>
  <div class="table">
    <div class="container">
      <div class="handle-box">
        <el-form label-width="120px" :model="queryCondition" ref="queryCondition" label-position="right" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="8位码" prop="eightBitCode" class="iconStyle">
                    <el-input class="handle-input" v-model="queryCondition.eightBitCodeStr" clearable type="textarea" :autosize="{maxRows:1}" style="width:100%"></el-input>
                    <i class="el-icon-menu" @click="menuClick"></i>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="8位码名称" prop="eightBitCodeName">
                    <el-input class="handle-input" v-model="queryCondition.eightBitCodeName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="提货点" prop="tmPickupId">
                    <ic-select table="BASE" field="PICKUP_POINT" v-model="queryCondition.tmPickupId" filterable clearable style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="DC" prop="dcIdList">
                    <ic-select filterable table="BASE" field="DC" v-model="queryCondition.dcIdList" multiple clearable style="width:100%"></ic-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="温区" prop="temperature">
                      <el-select v-model="queryCondition.temperature" class="handle-input" clearable style="width:100%">
                        <el-option :label="$t('common.all')" value></el-option>
                        <el-option :key="index" v-for="(item,index) in temperatureList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="运输方式" prop="transportaionMethod">
                      <el-select v-model="queryCondition.transportaionMethod" filterable clearable class="handle-input" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in transportaionMethodList" :label="item | inputChoiceI18n" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="承运商" v-if="emplFlag == 'MCD'" prop="lineSupplierId">
                      <ic-select table="BASE" field="CARRIER" v-model="queryCondition.lineSupplierId" filterable clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="非标准线路运费" prop="isSpecialFreight">
                      <ic-select table="COMMON" field="YES_NO" v-model="queryCondition.isSpecialFreight" filterable clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="报价确认时间(从)" prop="beginUpdateDate">
                      <el-date-picker style="width:100%" value-format="yyyy-MM-dd" v-model="queryCondition.beginUpdateDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="报价确认时间(至)" prop="endUpdateDate">
                      <el-date-picker style="width:100%" value-format="yyyy-MM-dd" v-model="queryCondition.endUpdateDate" type="date" :placeholder="$t('common.selDate')"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <ic-select table="COMMON" field="DISABLE_ENABLE_CODE" v-model="queryCondition.status" clearable style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button size="mini" @click="restQueryForm" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <div class="action-btn-row">
        <el-button size="mini" class="btn" @click="priceChange()" type="primary" v-acl="materialProApplyCreateChangeApply">产品价格变更</el-button>
        <el-button size="mini" class="btn" @click="exportData()" type="primary" v-acl="Product-freightsExcel">导出</el-button>
        <el-button size="mini" class="btn" @click="prohibited('disable')" type="primary" v-acl="Product-freightsDisable">运费禁用</el-button>
        <el-button size="mini" class="btn" @click="prohibited('enable')" type="primary" v-acl="Product-freightsDisable">运费启用</el-button>
        <el-button size="mini" class="btn" @click="sendToMDM()" type="primary" v-acl="send_product_freight_to_mdm">{{$t("base.productFreight.sendToMDM")}}</el-button>
        <el-button size="mini" class="btn" @click="deliveryTypeFunc" type="primary" v-acl="MaintainCarrierDeliveryType">配送类型</el-button>

      </div>
      <el-table :data="tableDetail" row-key="tmProductFreightId" ref="tableDetailRef" @selection-change="findCarrierCode" border max-height='600' highlight-current-row>
        <el-table-column sortable reserve-selection type="selection" width="55" align="center" fixed></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="eightBitCode" label="8位码" min-width="70px" fixed></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="eightBitCodeName" label="8位码名称" min-width="130px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="tmPickupId" label="提货点" min-width="90px">
          <template slot-scope="scope">{{scope.row.tmPickupId | ic('BASE','PICKUP_POINT')}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="tmDcId" label="到货仓库（DC）" min-width="130px">
          <template slot-scope="scope">{{scope.row.tmDcId | ic('BASE','DC')}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="temperature" label="温区" min-width="80px">
          <template slot-scope="scope">{{scope.row.temperature | ic('COMMON','TEMPERATURE')}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="transportaionMethod | ic('COMMON','TRANSPORTAION_METHOD')" label="运输方式" min-width="90px">
          <template slot-scope="scope">{{scope.row.transportaionMethod | ic('COMMON','TRANSPORTAION_METHOD')}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="productPrice" :label="$t('base.productFreight.productPrice')" min-width="150px" header-align="center"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="effectiveBeginDate" label="产品有效开始日期" width="150">
          <template slot-scope="scope">{{scope.row.effectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="futureProductPrice" :label="$t('base.productFreight.futureProductPrice')" min-width="180px" header-align="center"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="futureEffectiveBeginDate" label="未来产品有效开始日期" width="170px">
          <template slot-scope="scope">{{scope.row.futureEffectiveBeginDate | dateFormatFilter("YYYY-MM-DD")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="linePrice" label="线路价格" min-width="90px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="lineUnit" label="结算单位" min-width="90px"><template slot-scope="scope">{{scope.row.lineUnit|ic("COMMON","UNIT")}}</template></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="lineSupplierId" label="线路承运商" min-width="100px">
          <template slot-scope="scope">
            {{scope.row.lineSupplierId | ic("BASE",'CARRIER')}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="tmSupplier" label="8位码供应商" min-width="170">
          <template slot-scope="scope">
            {{scope.row.tmSupplierId | ic("BASE",'SUPPLIER')}}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="eightBitCodePlantName" label="8位码工厂" min-width="170"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="isSpecialFreight" label="非标准线路运费" min-width="140px">
          <template slot-scope="scope">{{scope.row.isSpecialFreight|ic("COMMON","YES_NO")}}</template>
        </el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="externalPackagingLength" label="外包装长(cm)" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="externalPackagingWidth" label="外包装宽(cm)" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="externalPackagingHeight" label="外包装高(cm)" min-width="120px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="externalPackagingNetweight" label="外包装净重(kg)" min-width="130px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="externalPackagingGrossweight" label="外包装毛重(kg)" min-width="130px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="palletItemsLength" label="托盘上物品长度(cm)" min-width="150px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="palletItemsWidth" label="托盘上物品宽度(cm)" min-width="150px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="palletItemsHeight" label="托盘上物品高度(cm)" min-width="150px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="palletLayerNumber" label="每Pallet层数" min-width="110px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="palletLayerBoxNumber" label="每层箱数" min-width="90px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="status" label="状态" min-width="80px"><template slot-scope="scope">{{scope.row.status|ic("COMMON","DISABLE_ENABLE_CODE")}}</template></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="remarks" :label="$t('common.remarks')" min-width="100px"></el-table-column>
        <el-table-column show-overflow-tooltip sortable prop="updateDate" :label="$t('base.productFreight.updateDate')" min-width="120px"><template slot-scope="scope">{{scope.row.updateDate|dateFormatFilter}}</template></el-table-column>
        <el-table-column show-overflow-tooltip sortable align="center" :label="$t('base.linePrice.operation')" min-width="100px" fixed="right">
          <template slot-scope="scope">
            <el-link @click="getFistories(scope.row)" v-acl="Product-freightsHistories" type="primary">{{$t('base.linePrice.history')}}</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>

      <!-- 到货仓库 -->
      <el-dialog :visible.sync="showSelDcMultipleDialog" append-to-body width="80%">
        <SelDc ref="selectDcMultipleRef" :multipleSelectionFlag="false" @subCallMethod="selectDcMethod"></SelDc>
      </el-dialog>
      <el-dialog :visible.sync="dialogTableVisible" width="40%" :close-on-click-modal="false">
        <dialog-table v-if="dialogTableVisible" :gridData="gridData"></dialog-table>
      </el-dialog>
      <el-dialog title="配置配送类型" :visible.sync="dialogDeliveryTypeVisible" width="40%" :close-on-click-modal="false" append-to-body class="fpa">
        <el-row style="margin-bottom:8px">
          <el-button size="mini" class="btn" type="primary" @click="onAdd">新增新的物流服务商</el-button>
        </el-row>
        <el-form :model="deliveryTypeForm" ref="deliveryTypeForm">
          <el-table :data="deliveryTypeForm.deliveryTypeData" max-height="400px" border stripe style="width: 100%">
            <el-table-column label="操作" width="80px">
              <template slot-scope="scope">
                <el-button type="text" @click="onDelete(scope.row,scope.$index)" v-if="scope.row.carrierCode!=='OTHER'">删除</el-button>
              </template>
            </el-table-column>
            <el-table-column prop="carrierCode" label="物流服务商">
              <template slot-scope="scope">
                <el-form-item :prop="`deliveryTypeData.${scope.$index}.carrierCode`" :rules="carrierCodeRules(scope.$index, scope.row)">
                  <el-select v-model="scope.row.carrierCode" @change="carrierCodeChange($event,scope.$index)" :disabled="scope.row.carrierCode=='OTHER'" style="width: 100%">
                    <el-option v-for="(item, index) in carrierCodeLists" :key="index" :value="item.supplierCode" :label="item.supplierName"></el-option>
                  </el-select>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column prop="deliveryType" label="配送类型">
              <template slot-scope="scope">
                <el-form-item :prop="`deliveryTypeData.${scope.$index}.deliveryType`" :rules="deliveryTypeRules(scope.$index, scope.row)">
                  <ic-select table="TT_CARRIER_DELIVERY_TYPE" field="DELIVERY_TYPE" v-model="scope.row.deliveryType" clearable style="width:100%"></ic-select>
                </el-form-item>
              </template>
            </el-table-column>
          </el-table>
        </el-form>
        <el-row :gutter="10" type="flex" justify="center" style="margin-top:8px">
          <el-button size="mini" class="btn" @click="onConfirm" type="primary">确定</el-button>
          <el-button size="mini" class="btn" @click="onCancel" type="primary">取消</el-button>
        </el-row>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import { inputChoiceService } from "@/api/common/input-choice";
import { search } from "../../../api/base-data/supplier";
import {
  saveDeliveryType,
  getDeliveryType,
  getfreightsList,
  excelfreightsList,
  getfreightsHistories,
  freightProhibited, sendToMDM, freightEnable
} from "@/api/base-data/materialPriceData";
import { downloadFile } from "../../../api/base-data/linePriceData";
import SelDc from "@/components/page/base-data/dc-sel-page";

import { fileService } from "@/api/common/file-utils";
import IcSelect from "@/components/common/icSelect";
import commonFun from "@/utils/commonFun";
import { applyService } from "@/api/quotation-apply/quotation-apply";
import { Message } from "element-ui";
import commonFunction from "../../../utils/dataTableUtils"
import store from '@/store/index'
import paginationMixin from '../../../mixins/pagitionMixin';
import dialogTable from "../../common/dialogTable.vue";
export default {
  name: "materialPriceData",
  mixins: [paginationMixin],
  components: { IcSelect, SelDc, dialogTable },
  data() {
    return {
      deliveryTypeForm: {
        deliveryTypeData: []
      },
      rules: {},
      dialogDeliveryTypeVisible: false,
      dialogTableVisible: false,//批量查询弹窗控制
      gridData: [],//批量多选列表
      isShow: false,//控制查询列表收缩展开
      totalCount: 0,
      queryCondition: {
        beginUpdateDate: "",
        endUpdateDate: "",
        eightBitCodeStr: '',
        eightBitCodeList: [],
        eightBitCodeName: '',
        tmPickupId: '',
        dcIdList: [],
        temperature: '',
        transportaionMethod: '',
        lineSupplierId: '',
        isSpecialFreight: '',
        pageNum: 1, //当前页
        pageSize: 15, //每页多少条
        productFreightIdList: [],
        status: "",
      },
      showSelDcMultipleDialog: false,
      temperatureList: [],
      transportaionMethodList: [],
      tableDetail: [],
      carriers: [],
      emplFlag: '',
      carrierCodeLists: [],

    };
  },
  watch: {
    queryCondition() {
      let _this = this;
      _this.queryCondition.eightBitCode = commonFun.trim(_this.queryCondition.eightBitCode);
      _this.queryCondition.eightBitCodeName = commonFun.trim(_this.queryCondition.eightBitCodeName);
      _this.queryCondition.pickupPoint = commonFun.trim(_this.queryCondition.pickupPoint);
      store.dispatch('uploadListParams', { routeName: _this.$route.name, reqData: _this.queryCondition })
    }
  },
  beforeRouteEnter(to, from, next) {
    getfreightsList(to.meta.reqData).then((res) => {
      next(vm => {
        vm.queryCondition = to.meta.reqData;
        vm.tableDetail = res.data.records;
        vm.totalCount = res.data.total;
      })
    })
  },
  created() {
    // this.queryData(1);
    this.getInputChoiceValues();
    this.getCarrierData()

    //用户所属系统
    this.emplFlag = localStorage.getItem('ms_emplFlag');
  },
  methods: {
    carrierCodeRules(index, row) {
      return (this.rules["carrierCode"] = [
        {
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('Can not be empty'));
            };
            const hasDuplicateId = this.hasDuplicateValue(this.deliveryTypeForm.deliveryTypeData, 'carrierCode');
            console.log("GY🚀 ~ file: materialPriceData.vue:304 ~ carrierCodeRules ~ hasDuplicateId:", hasDuplicateId);
            if (hasDuplicateId) {
              return callback(new Error('物流服务商不能重复'));
            }
            callback();
          },
          trigger: "change",
        }
      ]);
    },
    deliveryTypeRules(index, row) {
      return (this.rules["deliveryType"] = [
        {
          validator: (rule, value, callback) => {
            if (!value) {
              return callback(new Error('Can not be empty'));
            };
            callback();
          },
          trigger: "change",
        }
      ]);
    },
    deliveryTypeFunc() {
      getDeliveryType().then(res => {
        console.log("GY🚀 ~ file: materialPriceData.vue:284 ~ getDeliveryType ~ res:", res);
        if (res.code == '200') {
          this.$nextTick(() => {
            this.deliveryTypeForm.deliveryTypeData = res.data
            this.dialogDeliveryTypeVisible = true
          })
        }
      })
    },
    carrierCodeChange(val, index) {
      console.log("GY🚀 ~ file: materialPriceData.vue:339 ~ carrierCodeChange ~ val:", val);
      if (val) {
        var arr = this.carrierCodeLists.filter(ele => ele.supplierCode == val)
        this.deliveryTypeForm.deliveryTypeData[index].carrierName = arr[0].supplierName
      } else {
        this.deliveryTypeForm.deliveryTypeData[index].carrierName = ''
      }
    },
    getCarrierData() {
      search({
        pageSize: 9999,
        pageNum: -1,
        status: '',
        supplierCode: '',
        supplierName: '',
        type: 'CARRIER',
      }).then((res) => {
        console.log("GY🚀 ~ file: materialPriceData.vue:336 ~ getCarrierData ~ res:", res);
        this.carrierCodeLists = res.resultData;
        this.carrierCodeLists.push({
          supplierCode: "OTHER",
          supplierName: "其他",
        })
      })
    },
    onAdd() {
      var item = {
        carrierCode: "",
        carrierName: "",
        deliveryType: "",
        ttCarrierDeliveryTypeId: ""
      }
      this.deliveryTypeForm.deliveryTypeData.unshift(item)
    },
    onDelete(row, index) {
      this.$confirm('请确认是否删除此条配置信息?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.deliveryTypeForm.deliveryTypeData.splice(index, 1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    onConfirm() {
      this.$refs['deliveryTypeForm'].validate((valid) => {
        if (valid) {
          saveDeliveryType(this.deliveryTypeForm.deliveryTypeData).then(res => {
            console.log("GY🚀 ~ file: materialPriceData.vue:366 ~ saveDeliveryType ~ res:", res);
            if (res.code == '200') {
              this.$message.success('操作成功')
              this.dialogDeliveryTypeVisible = false
            }
          })
        }
      })
    },
    hasDuplicateValue(array, property) {
      const values = array.map(item => item[property]);
      return new Set(values).size !== new Set(array).size;
    },
    onCancel() {
      this.dialogDeliveryTypeVisible = false
    },
    menuClick() {
      this.gridData = this.queryCondition.eightBitCodeStr;
      this.dialogTableVisible = true;
    },
    queryData: function (val) {
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      const eightBitCodeStr = this.queryCondition.eightBitCodeStr
      console.log('eightBitCodeStr', eightBitCodeStr);
      let eightBitCodeArr = []
      if (eightBitCodeStr && eightBitCodeStr.length > 0) {
        eightBitCodeArr = eightBitCodeStr.replace(/(^\s*)|(\s*$)/g, "").split(/[\n,，\s]+/g);
      }
      this.$set(this.queryCondition, 'eightBitCodeList', eightBitCodeArr)
      // this.queryCondition.eightBitCode = commonFun.trim(this.queryCondition.eightBitCode);
      this.queryCondition.eightBitCodeName = commonFun.trim(this.queryCondition.eightBitCodeName);
      this.queryCondition.pickupPoint = commonFun.trim(this.queryCondition.pickupPoint);
      getfreightsList(this.queryCondition).then(res => {
        this.tableDetail = res.data.records;
        this.totalCount = res.data.total;
      });
    },
    //产品价格变更
    priceChange() {
      let rows = this.$refs.tableDetailRef.selection;
      if (rows.length == 0) {
        this.$message({ message: "请选择需要变更的数据", type: "warning" });
      } else {
        let lineId = [];
        rows.forEach((item) => {
          lineId.push(item.tmProductFreightId)
        });
        if (this.emplFlag == 'SUP') {
          this.$router.push({
            path: `/materialPriceData-priceChange`,
            query: { applyId: lineId, source: 'SUP' }
          });
        } else {
          this.$router.push({
            path: `/materialPriceData-priceChange`,
            query: { applyId: lineId, source: 'MCD' }
          });
        }
      }
    },
    //运费禁用
    prohibited(status) {
      let that = this;
      let data = {
        tmProductFreightId: this.carriers
      }
      if (this.carriers.length == 0) {
        this.$message({ message: `请选择需要${status == 'disable' ? '禁用' : '启用'}的数据`, type: "warning" });
      } else {
        if (status == 'disable') {
          this.$confirm(this.$t('base.productFreight.sureDisable'), this.$t('common.tips'), {
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel'),
            customClass: 'colorBtn',
            type: 'warning'
          }).then(() => {
            freightProhibited(this.carriers).then(res => {
              console.log(res);
              if (res.code == 200) {
                this.$message({ message: "禁用成功", type: "success" });
                that.queryData();
              }
            });
          }).catch(() => {

          });
        } else {
          freightEnable(this.carriers).then(res => {
            console.log(res);
            if (res.code == 200) {
              this.$message({ message: "启用成功", type: "success" });
              that.queryData();
            }
          });
        }

      }

    },
    //多选选中的数据
    findCarrierCode(val) {
      this.carriers = [];
      this.queryCondition.productFreightIdList = [];
      val.forEach((item) => {
        this.carriers.push(item.tmProductFreightId);
        this.queryCondition.productFreightIdList.push(item.tmProductFreightId);
      });
    },
    getFistories(row) {
      this.$router.push({
        path: `/materialPriceData-history`,
        query: {
          tmProductFreightId: row.tmProductFreightId,
          eightBitCode: row.eightBitCode
        }
      });

    },
    //查询条件重置方法
    restQueryForm() {
      this.$refs.queryCondition.resetFields();
      this.queryCondition = {
        eightBitCodeStr: '',
        eightBitCodeList: [],
        eightBitCodeName: '',
        tmPickupId: '',
        dcIdList: [],
        temperature: '',
        transportaionMethod: '',
        lineSupplierId: '',
        isSpecialFreight: '',
        pageNum: 1, //当前页
        pageSize: 15, //每页多少条
        productFreightIdList: [],
        beginUpdateDate: "",
        endUpdateDate: "",
      }
      this.$refs.tableDetailRef.clearSelection();
      this.queryData();
    },
    exportData() {
      console.log('this.queryCondition', this.queryCondition);
      excelfreightsList(this.queryCondition).then(res => {
        fileService.respToFile(res);
      });
    },
    //下拉列表数据获取
    getInputChoiceValues() {
      let mapObj = {};
      mapObj["COMMON:UNIT"] = "COMMON:UNIT";
      mapObj["COMMON:TEMPERATURE"] = "COMMON:TEMPERATURE";
      mapObj["COMMON:TRANSPORTAION_METHOD"] = "COMMON:TRANSPORTAION_METHOD";
      inputChoiceService.getInputChoiceValues(mapObj).then(res => {
        this.temperatureList = res["COMMON:TEMPERATURE"];
        this.transportaionMethodList = res["COMMON:TRANSPORTAION_METHOD"];
      });
    },
    sendToMDM() {
      let rows = this.$refs.tableDetailRef.selection;
      if (rows.length == 0) {
        this.$message({ message: this.$t('common.pleaseSelectData'), type: "warning" });
        return;
      } else {
        let lineId = [];
        rows.forEach((item) => {
          lineId.push(item.tmProductFreightId)
        });
        sendToMDM(lineId).then(response => {
          Message.success(this.$t('common.operateSuccess'));
        });
      }
    },
    //到货仓库选择
    selectDcMethod: function (dcList) {
      let _this = this;
      if (this.multipleSelectionBl) {
        //多选
        let codes = new Array();
        let dcIds = new Array();
        dcList.forEach(item => {
          dcIds.push(item.tmDcId);
          codes.push(item.dcName);
        });
        _this.applyLineNew.dcName = codes.join(",");
        _this.applyLineNew.dcIds = dcIds;
      } else {
        //单选
        this.tempRows.tmDcId = dcList[0].tmDcId;
        this.tempRows.dcName = dcList[0].dcName;
      }
      this.showSelDcDialog = false;
      this.showSelDcMultipleDialog = false;
    }
  },
  extends: commonFunction
};
</script>
<style scoped lang="scss">
</style>
